import styled from 'styled-components';
import {dFlexColumnCenter, dInlineFlex, alignCenter, justifyCenter} from '../../globalVariables/GlobalFlex';
import {getFontSize, getFontWeight, getToken, getSpacing} from '@tickchak/react-share/app';

export const empty = styled.div`
    ${dFlexColumnCenter};
    gap: 16px;
    padding: 48px ${getSpacing('spaceXl')};
    text-align: center;
`;

export const emptyIcon = styled.div`
    width: 44px;
    height: 44px;
    border-radius: 100px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 22px 22px;
`;

export const emptyText = styled.p`
    margin: 0;
    font-family: 'Assistant', sans-serif;
    font-weight: ${getFontWeight('regular')};
    font-size: ${getFontSize('body')};
    line-height: 1.4;
    color: ${getToken('color.text.default')};
`;

export const emptyAction = styled.button`
    ${dInlineFlex}
    ${alignCenter}
    ${justifyCenter}
    height: 32px;
    padding: 0 ${getSpacing('spaceLg')};
    background: ${getToken('color.brand.main')};
    border: none;
    border-radius: 100px;
    cursor: pointer;
    font-family: 'Assistant', sans-serif;
    font-weight: ${getFontWeight('bold')};
    font-size: ${getFontSize('textButtonCategory')};
    line-height: 16px;
    color: ${getToken('color.text.default')};
`;
